import "core-js/modules/es6.object.freeze";
export var cornerRadii = Object.freeze({
  none: '0',
  small: '4px',
  "default": '0',
  imageDefault: '0',
  circle: '50%'
});
export var cornerRadiiRefresh = Object.freeze({
  none: '0',
  small: '4px',
  "default": '4px',
  imageDefault: '0',
  circle: '9999px'
});